import { useEffect, useState, useContext, useRef } from "react";
import {
  annotation_state,
  annotation_state_store,
} from "../../pages/Annotations/helper/initialData";
import {
  getAllPathologies,
  getSelectedPathologies,
  regenerateReport,
} from "../../service/StudyReportService";
import studyReportContext from "../studyreport/StudyReportContext";
import StudyReportState from "../studyreport/StudyReportState";
import studyviewerContext from "../studyviewer/StudyviewerContext";
import AgenticReportingContext from "../agentic-reporting/AgenticReportingContext";
import ViewportContext from "../studyviewer/ViewportContext";
import AnnotationContext from "./AnnotationContext";
import { StackScrollTool } from "@cornerstonejs/tools";
import { getExtraFieldJson } from "../../pages/Annotations/helper/generalFracture";
import {
  API_BASE_URL,
  APIs,
  COLORS,
  DEFAULT_TOOL,
  SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST,
  TOAST_TYPE,
  USERTYPES,
  XRAY_DEFAULT_TOOL,
} from "../../constants/Constants";
import { validateSpine } from "../../pages/Annotations/helper/SpineValidation";
import { validateGeneralFractureAnnotation } from "../../pages/Annotations/helper/GeneralFractureValidation";
import { general_fracture_validation_data } from "../../pages/Annotations/helper/GeneralFractureData";
import { validateCovidSuspectAnnotation } from "../../pages/Annotations/helper/CovidSuspectValidation";
import { covid_suspect_validation_data } from "../../pages/Annotations/helper/CovidSuspectValidationData";
import loaderContext from "../loader/LoaderContext";
import { Editor, Transforms } from "slate";
import ToastState from "../toast/ToastState";
import toastContext from "../toast/ToastContext";
import userContext from "../users/UserContext";
import { getViewport } from "../../pages/StudyViewer/helpers/CornerstoneViewportService";
import { getCornerstoneLegacyJson } from "../../pages/StudyViewer/helpers/BoundingBoxUtilities";
import { resizeViewport } from "../../pages/StudyViewer/helpers/CornerstoneViewportService";
import ThumbnailContext from "../studyviewer/ThumbnailContext";
import Moment from "moment";
import { isMobile } from "react-device-detect";

const AnnotationState = (props) => {
  const {
    annotationsJson,
    setAnnotationsJson,
    studyOptionJson,
    setStudyOptionJson,
    handleAnnotationJsonData,
    disablePenEye,
    patientReports,
    setPatientReports,
    setCurrentActiveTab,
    setModel,
    handleModelChange,
    handleChangeTemplate,
    setEnableReportRegenerate,
    enableReportRegenerate,
    setReportAnnotationState,
    setShowToast,
    showToast,
    regenerateSmartReport,

    setAlertSuccessModal,
    alertSuccessModal,
    reportSavedSuccess,
    setAllStoreAnnotation,
    addStoreAnnotationState,
    setAddStoreAnnotationState,
    isClientReportExist,
    handleSubmitReport,
  } = useContext(studyReportContext);

  const {
    editWarning,
    setEditWarning,
    handlePencilClick,
    setActiveTool,
    setPreviousActiveTool,
    handleDeleteSmartTag,
    annotationData,
    disableAddPathology,
    setDisableAddPathology,
    setAnnotationAddedSuccess,
    activeViewportIndex,
    annotationDataAI,
    databasePointsToMeasurement,
    addLockedAIPathology,
    addAiBb,
    addedAnnotation,
    setAddedAnnotation,
    setAddedStoreAnnotation,
    setParentLockReference,
    archivedPathology,
    setArchivedPathology,
    handleDefaultToolChange,
    activeTool,
    setBoundingBoxMode,
    handleRemoveWarning,
    updateBBPosition,
    disableMasking,
    allTextToolAnnotation,
    addBoundingBoxToViewport,
  } = useContext(ViewportContext);

  const {
    studyParentId,
    reportSavedBy,
    setReportSavedBy,
    autoGenerateReportData,
    setAutoGenerateReportData,
    parentChildReportsObj,
    sharedViewer,
    priorStudyResponseData,
    firmViewerId,
    cxrVersion,
    studyBoundingBox,
    keyImages,
    setReportMenu,
    setSeriesMenu,
    showFindingsHighlighted,
    showProbablilityScores
  } = useContext(studyviewerContext);

  const {isChildStudyReportState, autoPopulateManualPathology, activeTabKey} = useContext(studyReportContext);
  const { inputValue, setInputValue, getChatInputRef } = useContext(AgenticReportingContext);

  const { activeStudyId,activeModality } = useContext(ThumbnailContext);

  const { roles, username, authenticated, loadByUsername, userId, qcReviewer, enableLlmReport } =
    useContext(userContext);

  const { showToastv2 } = useContext(toastContext);
  const { ref, refAnnotation, setLoaderRunning, setLoaderAnnotationRunning } =
    useContext(loaderContext);
  const [allAnnotations, setAllAnnotation] = useState([]);
  const [classificationStateStore, setClassificationStateStore] = useState([]);
  const [childClassificationState, setChildClassificationState] = useState([]);
  const [allStoreAnnotations, setAllStoreAnnotations] = useState([]);
  const [regeneratedReport,setRegeneratedReport] = useState([]);
  const [annotationState, setAnnotationState] = useState(annotation_state);
  const [annotationStateStore, setAnnotationStateStore] = useState(
    JSON.parse(JSON.stringify(annotation_state))
  );
  //const [addedAnnotation, setAddedAnnotation] = useState([]);
  const [abbreviatedAnnotation, setAbbreviatedAnnotation] = useState({});
  const [addedAnnotationLength, setAddedAnnotationLength] = useState(0);
  const [addedChildAnnotation,setAddedChildAnnotation] = useState({});
  const [childPathologyPresentObj, setChildPathologyPresentObj] = useState({});
  const [studyId, setStudyId] = useState(studyParentId);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [tempAnnotation, setTempAnnotation] = useState([]);
  const [paginatedAnnotation, setPaginatedAnnotation] = useState({});
  const [testPatientViewer, setTestPatientViewer] = useState({});
  const [firstRunSmartReport, setFirstRunSmartReport] = useState(false);
  const [pathologiesLoading,setPathologiesLoading] = useState(false);

  const [tabs, setTabs] = useState(null);
  const [checkTab, setCheckedTab] = useState(0);
  const [tabContent, setTabContent] = useState([]);

  const [dataForAutoGenerationUpdated, setDataForAutoGenerationUpdated] =
    useState(false);

  const dimension = useRef(null);

  // Snapshot of the parent study's own locked/unlocked pathology list, so that
  // switching to view a child/prior study (which temporarily repoints
  // addedStoreAnnotation at the child's data, see handleAddingChildPathologies)
  // can restore the parent's list when the user switches back to it.
  const parentAddedStoreAnnotationRef = useRef(null);
  // Tracks which child/prior study IDs have already had their bounding boxes
  // drawn into the viewport, so revisiting one only resyncs which study's
  // lock data is "active" without re-adding the same annotations.
  const childBoundingBoxDrawnRef = useRef(new Set());
  // Per-child-study cache of the pre-mutation pathology list (see
  // rawAnnotationsForBoxes in handleAddingChildPathologies), keyed by study id,
  // so revisiting an already-fetched child study can still resync
  // addedStoreAnnotation with its real lock state.
  const rawChildAnnotationForBoxesRef = useRef({});

  // Draws a child/prior study's own bounding boxes (once per study) and makes
  // its pathology list the one addBoundingBoxToViewport uses to decide which
  // tags are locked (visible) vs AI-suggested (hidden) — see the is_locked
  // check in addBoundingBoxToViewport. Without this, a child study opened via
  // the priors flow never gets its own boxes drawn: box-drawing was only ever
  // wired to the parent study's pathology fetch (getAllPathology below).
  const syncChildStudyBoundingBoxes = (studyIdToSync, pathologyList) => {
    setAddedStoreAnnotation(pathologyList || []);
    if (childBoundingBoxDrawnRef.current.has(studyIdToSync)) return;
    const childStudyDto = priorStudyResponseData?.studyDtoList?.find(
      (study) => study.id == studyIdToSync
    );
    const childBoundingBox =
      childStudyDto?.studyAnnotationMeasurement?.imageAnnotationMeasurements;
    if (childBoundingBox?.length > 0) {
      childBoundingBoxDrawnRef.current.add(studyIdToSync);
      // Pass the list directly rather than relying on the addedStoreAnnotation
      // state set just above — that setState hasn't committed yet, so
      // addBoundingBoxToViewport would otherwise read the previous study's
      // (or empty) lock data and treat every tag as locked/visible.
      addBoundingBoxToViewport(childBoundingBox, true, pathologyList || []);
    }
  };

  const getAllPathology = async (studyParentId, reportSavedBy) => {
    try {
      setPathologiesLoading(true);
      let res = await getAllPathologies(studyParentId, +firmViewerId);
      if (res.status === 200) {
        let opt = [];
        let data = res.data.data.allAnnotations;
        let response = res.data.data;

        let allAnnotation = response?.allAnnotations?.map((ele, index) => {
          if (ele.viewed == undefined || ele.viewed == null) {
            ele["viewed"] = false;
          }
          if (ele.isAI == undefined || ele.isAI == null) {
            ele["isAI"] = false;
          }
          if (ele.isAIEdited == undefined || ele.isAIEdited == null) {
            ele["isAIEdited"] = false;
          }
          if (
            ele.corrPathPrediction != null &&
            ele.corrPathPrediction > 0 &&
            ele.is_present == 1
          ) {
            if (ele.is_annotated == undefined || ele.is_annotated == null) {
              ele["is_annotation_check"] = false;
            } else if (ele.is_annotated == true) {
              ele.is_annotated = false;
            }

            if (ele.is_locked == undefined || ele.is_locked == null) {
              ele["is_locked_check"] = false;
            } else if (ele.is_locked == true) {
              ele.is_locked = false;
            }
            return ele;
          } else {
            return ele;
          }
        });
        setAnnotationState(() => {
          const newVal = { ...annotationState };
          newVal.extra_value = JSON.parse(response.extravalue);
          newVal.annotations_stuff = allAnnotation;
          newVal.reportDoneStatus = response.reportDoneStatus;
          newVal.expReviewDoneStatus = response.expReviewDoneStatus;
          newVal.defaultSubOpts = response.optionDefaultValues;
          return newVal;
        });
        setAnnotationStateStore(() => {
          const newVal = { ...annotationStateStore };
          newVal.extra_value = JSON.parse(response.extravalue);
          newVal.annotations_stuff = allAnnotation;
          newVal.reportDoneStatus = response.reportDoneStatus;
          newVal.expReviewDoneStatus = response.expReviewDoneStatus;
          newVal.defaultSubOpts = response.optionDefaultValues;
          return newVal;
        });

        setAddStoreAnnotationState(() => {
          const newItem = { ...addStoreAnnotationState };
          newItem.annotations_stuff = JSON.parse(JSON.stringify(allAnnotation));
          return newItem;
        });

        setClassificationStateStore(res.data.data.allClassifications)

        getFilteredAnnotationList(data, reportSavedBy);
        setPathologiesLoading(false);
      }
    } catch (e) {
      setPathologiesLoading(false);
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = "Error while getting annotation metadata";
        return newItem;
      });
    }
  };

  useEffect(() => {
    if (studyParentId != undefined && !sharedViewer && !isMobile) {
      getAllPathology(studyParentId, reportSavedBy);
    }
  }, [studyParentId]);

  const handleAddingChildPathologies = async() => {
    let isActiveData = true;
    priorStudyResponseData?.studyDtoList?.forEach((study) => {
      if(study.id == activeStudyId) {
        isActiveData = study.fromActiveDatabase;
      }
    })
    let annotationObj = addedChildAnnotation;
    let childPathologyObj = childPathologyPresentObj;
    if(isChildStudyReportState && annotationObj[activeStudyId] == undefined){
      try{
        let pathologyPresent = false;
        setPathologiesLoading(true);
        const res = await getSelectedPathologies(activeStudyId, isActiveData);
        if(res.data.result === "SUCCESS"){
          let opt = [];
        let data = res.data.data.allAnnotations;
        let response = res.data.data;

        // Build the snapshot addBoundingBoxToViewport uses for its locked-vs-AI-suggested
        // split. A child/prior study's raw is_locked/is_annotated describe that study's OWN
        // finalized report (almost always "annotated"), not whether the smart tag is confirmed
        // for display here — that's what is_selected means, the same field NonEditablePathologyList
        // keys off to decide whether to show an AI tag. Derive is_locked/is_annotated from
        // is_selected for AI-predicted entries here, mirroring generateAnnotationsToDisplay's
        // is_locked_check derivation for the parent study, so an unselected smart tag is
        // correctly treated as unlocked and its box stays hidden.
        let rawAnnotationsForBoxes = JSON.parse(
          JSON.stringify(response?.allAnnotations || [])
        ).map((ele) => {
          if (ele.ai_predicted == 1) {
            const confirmed = !!ele.is_selected;
            return { ...ele, is_locked: confirmed, is_annotated: confirmed };
          }
          return ele;
        });

        let allAnnotation = response?.allAnnotations?.map((ele, index) => {
          if (ele.viewed == undefined || ele.viewed == null) {
            ele["viewed"] = false;
          }
          if (ele.isAI == undefined || ele.isAI == null) {
            ele["isAI"] = ele.ai_predicted;
          }
          if (ele.isAIEdited == undefined || ele.isAIEdited == null) {
            ele["isAIEdited"] = false;
          }
          if (
            ele.corrPathPrediction != null &&
            ele.corrPathPrediction > 0 &&
            ele.is_present == 1
          ) {
            if(!ele.ai_predicted || (ele.ai_predicted && ele.is_selected)){
              pathologyPresent = true;
            }
            if (ele.is_annotated == undefined || ele.is_annotated == null) {
              ele["is_annotation_check"] = false;
            } else if (ele.is_annotated == true) {
              ele.is_annotated = false;
            }

            if (ele.is_locked == undefined || ele.is_locked == null) {
              ele["is_locked_check"] = false;
            } else if (ele.is_locked == true) {
              ele.is_locked = false;
            }
            return ele;
          } else {
            return ele;
          }
        });
        annotationObj[activeStudyId] = allAnnotation;
        childPathologyObj[activeStudyId] = pathologyPresent
        setAddedChildAnnotation(annotationObj);
        setChildPathologyPresentObj(childPathologyObj);
        setChildClassificationState(res.data.data.allClassifications)
        setPathologiesLoading(false);
        rawChildAnnotationForBoxesRef.current[activeStudyId] = rawAnnotationsForBoxes;
        syncChildStudyBoundingBoxes(activeStudyId, rawAnnotationsForBoxes);
        }else{
          setPathologiesLoading(false);
        }
    }catch(e){
      setPathologiesLoading(false);
    }
    } else if (isChildStudyReportState && annotationObj[activeStudyId] != undefined) {
      // Already fetched on an earlier visit to this child study — just resync which
      // study's lock data is active; syncChildStudyBoundingBoxes itself skips redrawing
      // boxes that are already in the viewport.
      syncChildStudyBoundingBoxes(
        activeStudyId,
        rawChildAnnotationForBoxesRef.current[activeStudyId]
      );
    }
  }

  useEffect(() => {
    if(activeStudyId == studyParentId){
      // Switched back to the parent study — restore its own locked/unlocked
      // pathology list as the one addBoundingBoxToViewport reads, undoing the
      // repoint to a child study's data from syncChildStudyBoundingBoxes.
      if (parentAddedStoreAnnotationRef.current) {
        setAddedStoreAnnotation(parentAddedStoreAnnotationRef.current);
      }
    }else{
      handleAddingChildPathologies();
    }
    
  }, [activeStudyId,isChildStudyReportState]);

  useEffect(() => {
    if (annotationState.annotations_stuff.length > 0) {
      if (setSequeceNumForSelected()) {
        getStudyAnnotation();
        setDataForAutoGenerationUpdated(true);
      }
    }
  }, [annotationState.annotations_stuff.length]);

  useEffect(() => {
    if (
      Object.keys(annotationData).length > 0 &&
      dataForAutoGenerationUpdated
    ) {
      handleAutoGenerateReport();
    }
  }, [annotationData, dataForAutoGenerationUpdated]);

  useEffect(() => {
    if (reportSavedSuccess != null) {
      setReportSavedBy(userId);
      setArchivedPathology(null);
      setAnnotationState(annotation_state);
      getAllPathology(studyParentId, userId);
    }
  }, [reportSavedSuccess]);

  useEffect(() => {
    setReportAnnotationState(annotationState);
  }, [annotationState]);

  const setSequeceNumForSelected = () => {
    let tempAnnotationState = annotationState;
    for (let i = 0; i < annotationState.annotations_stuff.length; i++) {
      if (annotationState.annotations_stuff[i].is_present === 1) {
        tempAnnotationState.annotations_stuff[i].sequence_num =
          ++annotationState.sequence_num;
      }
    }
    setAnnotationState(() => {
      const newVal = { ...annotationState };
      newVal.annotations_stuff = tempAnnotationState.annotations_stuff;
      return newVal;
    });
    return true;
  };

  const handleUpdateAnnotationState = (id, add) => {
    let tempAnnotationState = annotationState.annotations_stuff;
    for (let i = 0; i < tempAnnotationState.length; i++) {
      if (annotationState.annotations_stuff[i].id === id) {
        tempAnnotationState[i].is_locked_check = add ? true : false;
        tempAnnotationState[i].is_locked = add ? true : false;
        tempAnnotationState[i].is_annotated = add ? true : false;
        tempAnnotationState[i].is_annotation_check = add ? true : false;
        tempAnnotationState[i].is_selected = add ? 1 : 0;
      }
    }
    setAnnotationState(() => {
      const newVal = { ...annotationState };
      newVal.annotations_stuff = tempAnnotationState;
      return newVal;
    });
  };

  useEffect(() => {
    setAllStoreAnnotation(addedAnnotation);
  }, [addedAnnotation]);

  const autoRegenerateReport = () => {
    let res = submitSelectedOptions();
    if (res != false) {
      setEnableReportRegenerate(false);
    }
  };

  const getStudyAnnotation = (pathology) => {
    generateIsOptionPresentMap();
    generateIsOptionPresentMapStore();
    generateSelections();
    generateSelectionsStore();

    //TODO: disable this for cxr analyser
    handleAddingAnnotations(pathology);
  };

  const handleAutoGenerateReport = () => {
    //Only Auto Generate Report when the AI output has come
    //but the report has not been saved/reported
    //this is only for normal with foreign bodies studies
    if (roles.includes(USERTYPES.RADIOLOGIST) && !isClientReportExist && !enableLlmReport) {
      if (
        !cxrVersion &&
        autoGenerateReportData.aiProcessed == 1 &&
        autoGenerateReportData.maxAIEmergency == 6
      ) {
        if (!(reportSavedBy != 0 || annotationState.reportDoneStatus != 0)) {
          autoRegenerateReport();
        }
      }
    }
  };

  const getFilteredAnnotationList = (data, reportSavedByTemp) => {
    let opt = [];
    let reportSavedByCheck =
      reportSavedByTemp == null || reportSavedByTemp == undefined
        ? reportSavedBy
        : reportSavedByTemp;
    data.map((ele, index) => {
      if (
        (ele.is_present == 0 &&
          ele.name != "Tuberculosis-Infiltrates" &&
          ele.isActive === true) ||
        (ele.is_present == 1 &&
          ele.ai_predicted == 1 &&
          ele.is_selected == 0 &&
          reportSavedByCheck > 0)
      ) {
        opt.push({
          id: ele.id,
          name: ele.name,
        });
      }
    });
    // for (let i = 0; i < opt.length; i++) {
    //   for (let j = 0; j < opt.length - i - 1; j++) {
    //     if (opt[j].name > opt[j + 1].name) {
    //       var temp = opt[j];
    //       opt[j] = opt[j + 1];
    //       opt[j + 1] = temp;
    //     }
    //   }
    // }
    setAllAnnotation(opt);
    setAllStoreAnnotations(opt);
    setAllStoreAnnotation(opt);
  };

  const generateIsOptionPresentMap = () => {
    let annotation_stuff = annotationState.annotations_stuff;
    let tempAnnotationState = annotationState;
    for (let i = 0; i < annotation_stuff.length; i++) {
      let annotationObj = annotation_stuff[i];
      let id = annotationObj.id;
      if (
        annotationObj.is_present === 1 &&
        !annotationObj.isActive &&
        !annotationObj.is_locked_check
      ) {
        continue;
      }
      if (
        !tempAnnotationState.annotations_options_presence_map.hasOwnProperty(id)
      ) {
        if (annotationObj.is_present === 1) {
          let group_numbers = annotationObj.group_numbers;
          tempAnnotationState.annotationVersionMap[id] = annotationObj.version;
          tempAnnotationState.annotations_options_presence_map[id] =
            group_numbers !== undefined &&
            group_numbers !== null &&
            group_numbers.length > 0
              ? 1
              : 0;
        }
      }
    }
    setAnnotationState(() => {
      const newVal = { ...annotationState };
      newVal.annotationVersionMap = tempAnnotationState.annotationVersionMap;
      newVal.annotations_options_presence_map =
        tempAnnotationState.annotations_options_presence_map;
      return newVal;
    });
  };

  const generateIsOptionPresentMapStore = () => {
    let annotation_stuff = annotationStateStore.annotations_stuff;
    let tempAnnotationState = annotationStateStore;
    for (let i = 0; i < annotation_stuff.length; i++) {
      let annotationObj = annotation_stuff[i];
      let id = annotationObj.id;
      if (
        annotationObj.is_present === 1 &&
        !annotationObj.isActive &&
        !annotationObj.is_locked_check
      ) {
        continue;
      }
      if (
        !tempAnnotationState.annotations_options_presence_map.hasOwnProperty(id)
      ) {
        if (annotationObj.is_present === 1) {
          let group_numbers = annotationObj.group_numbers;
          tempAnnotationState.annotationVersionMap[id] = annotationObj.version;
          tempAnnotationState.annotations_options_presence_map[id] =
            group_numbers !== undefined &&
            group_numbers !== null &&
            group_numbers.length > 0
              ? 1
              : 0;
        }
      }
    }
    setAnnotationStateStore(() => {
      const newVal = { ...annotationStateStore };
      newVal.annotationVersionMap = tempAnnotationState.annotationVersionMap;
      newVal.annotations_options_presence_map =
        tempAnnotationState.annotations_options_presence_map;
      return newVal;
    });
  };

  const generateSelections = () => {
    let annotation_stuff = annotationState.annotations_stuff;
    let finalObjGroupSelection = annotationState;
    for (let i = 0; i < annotation_stuff.length; i++) {
      let annotationObj = annotation_stuff[i];
      let id = annotationObj.id;
      if (!annotationState.selections.hasOwnProperty(id)) {
        if (annotationObj.is_present === 1) {
          let group_nums = annotationObj.group_numbers;

          if (
            group_nums !== undefined &&
            group_nums !== null &&
            group_nums.length > 0
          ) {
            for (let k = 0; k < group_nums.length; k++) {
              let group_number = group_nums[k];

              let groupObj =
                annotationObj.group_number_and_group_option_dto_map[
                  group_number
                ];
              if (groupObj.has_selections === 1) {
                let annotationGroupSelectionArr =
                  finalObjGroupSelection.group_selections[id];
                if (
                  annotationGroupSelectionArr === undefined ||
                  annotationGroupSelectionArr === null
                ) {
                  annotationGroupSelectionArr = [];
                  finalObjGroupSelection.group_selections[id] =
                    annotationGroupSelectionArr;
                }
                annotationGroupSelectionArr.push(group_number);
                finalObjGroupSelection.group_selections[id] =
                  annotationGroupSelectionArr;

                let option_ids = groupObj.option_ids;
                let annotationSelectionObj =
                  finalObjGroupSelection.selections[id];

                if (
                  annotationSelectionObj === undefined ||
                  annotationSelectionObj === null
                ) {
                  annotationSelectionObj = {};
                  finalObjGroupSelection.selections[id] =
                    annotationSelectionObj;
                }
                let array_of_selected_suboptions = [];
                for (let j = 0; j < option_ids.length; j++) {
                  let option_id = option_ids[j];
                  array_of_selected_suboptions = [];
                  annotationSelectionObj[option_id] =
                    array_of_selected_suboptions;

                  let suboption_ids =
                    groupObj.option_id_and_option_suboption_dto_map[option_id]
                      .suboption_ids;

                  for (let k = 0; k < suboption_ids.length; k++) {
                    let suboption_id = suboption_ids[k];

                    if (
                      groupObj.option_id_and_option_suboption_dto_map[option_id]
                        .suboption_id_and_suboption_details_map[suboption_id]
                        .is_selected === 1 ||
                      groupObj.option_id_and_option_suboption_dto_map[option_id]
                        .suboption_id_and_suboption_details_map[suboption_id]
                        .has_selected_suboption === 1
                    ) {
                      array_of_selected_suboptions.push(suboption_id);
                      finalObjGroupSelection.selections[id] =
                        annotationSelectionObj;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    setAnnotationState(() => {
      const newVal = { ...annotationState };
      newVal.group_selections = finalObjGroupSelection.group_selections;
      newVal.selections = finalObjGroupSelection.selections;
      return newVal;
    });
  };

  const generateSelectionsStore = () => {
    let annotation_stuff = annotationStateStore.annotations_stuff;
    let finalObjGroupSelection = annotationStateStore;
    for (let i = 0; i < annotation_stuff.length; i++) {
      let annotationObj = annotation_stuff[i];
      let id = annotationObj.id;
      if (!annotationStateStore.selections.hasOwnProperty(id)) {
        if (annotationObj.is_present === 1) {
          let group_nums = annotationObj.group_numbers;

          if (
            group_nums !== undefined &&
            group_nums !== null &&
            group_nums.length > 0
          ) {
            for (let k = 0; k < group_nums.length; k++) {
              let group_number = group_nums[k];

              let groupObj =
                annotationObj.group_number_and_group_option_dto_map[
                  group_number
                ];
              if (groupObj.has_selections === 1) {
                let annotationGroupSelectionArr =
                  finalObjGroupSelection.group_selections[id];
                if (
                  annotationGroupSelectionArr === undefined ||
                  annotationGroupSelectionArr === null
                ) {
                  annotationGroupSelectionArr = [];
                  finalObjGroupSelection.group_selections[id] =
                    annotationGroupSelectionArr;
                }
                annotationGroupSelectionArr.push(group_number);
                finalObjGroupSelection.group_selections[id] =
                  annotationGroupSelectionArr;

                let option_ids = groupObj.option_ids;
                let annotationSelectionObj =
                  finalObjGroupSelection.selections[id];

                if (
                  annotationSelectionObj === undefined ||
                  annotationSelectionObj === null
                ) {
                  annotationSelectionObj = {};
                  finalObjGroupSelection.selections[id] =
                    annotationSelectionObj;
                }
                let array_of_selected_suboptions = [];
                for (let j = 0; j < option_ids.length; j++) {
                  let option_id = option_ids[j];
                  array_of_selected_suboptions = [];
                  annotationSelectionObj[option_id] =
                    array_of_selected_suboptions;

                  let suboption_ids =
                    groupObj.option_id_and_option_suboption_dto_map[option_id]
                      .suboption_ids;

                  for (let k = 0; k < suboption_ids.length; k++) {
                    let suboption_id = suboption_ids[k];

                    if (
                      groupObj.option_id_and_option_suboption_dto_map[option_id]
                        .suboption_id_and_suboption_details_map[suboption_id]
                        .is_selected === 1 ||
                      groupObj.option_id_and_option_suboption_dto_map[option_id]
                        .suboption_id_and_suboption_details_map[suboption_id]
                        .has_selected_suboption === 1
                    ) {
                      array_of_selected_suboptions.push(suboption_id);
                      finalObjGroupSelection.selections[id] =
                        annotationSelectionObj;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    {/* NOTE: This is explicitily hardcoded for reseting cardiomegaly pathology */}
    if(finalObjGroupSelection?.selections[2] != null && finalObjGroupSelection?.selections[2] != undefined){
        if(finalObjGroupSelection?.selections[2][594]){
          finalObjGroupSelection.selections[2][594] = [2700];
        }
    }
    setAnnotationStateStore(() => {
      const newVal = { ...annotationStateStore };
      newVal.group_selections = finalObjGroupSelection.group_selections;
      newVal.selections = finalObjGroupSelection.selections;
      return newVal;
    });
  };

  const addStudyAnnotation = (annotationId) => {
    disableMasking(false);
    setBoundingBoxMode(false);
    const isAnalyzerModeWithoutAI = cxrVersion && !showFindingsHighlighted && !showProbablilityScores;

    if(cxrVersion && !isAnalyzerModeWithoutAI) {
      if (addLockedAIPathology(annotationId, true)) {
        const isArchived = archivedPathology?.some((item) => item.id === annotationId);
        addOrRemoveAnnotation(annotationId, 1, true, !isArchived);
      }
      updateBBPosition(studyBoundingBox, true, true, annotationId);
    } else if (archivedPathology?.some((item) => item.id === annotationId)) {
     if (addLockedAIPathology(annotationId, true)) {
        addOrRemoveAnnotation(annotationId, 1, true, false);
      }
      addAiBb(annotationId);
    } else {
      addOrRemoveAnnotation(annotationId, 1, false, true);
    }
    
    if (autoPopulateManualPathology && (setInputValue || getChatInputRef)) {
      let pathologyName = "";
      for (const cat of classificationStateStore) {
        const found = cat.pathologies?.find(p => p.id === annotationId);
        if (found) {
          pathologyName = found.name;
          break;
        }
      }
      if (pathologyName) {
        const sentence = `${pathologyName} is noted.`;
        
        const editor = getChatInputRef ? getChatInputRef(activeTabKey) : null;
        if (editor) {
          Transforms.insertText(editor, "\n" + sentence, { at: Editor.end(editor, []) });
        } else if (setInputValue) {
          setInputValue(inputValue ? inputValue + "\n" + sentence : sentence);
        }
      }
    }
  };

  const selectAIPathology = (id) => {
    disableMasking();
    setEnableReportRegenerate(true);
    handleRemoveWarning();
    let temp = [];
    let lockedItem = null;
    temp = addedAnnotation.map((item, ind) => {
      if (item.id == id) {
        if (item.is_locked_check != undefined && item.is_locked_check == false)
          item.is_locked_check = true;
        if (
          item.is_locked_check != undefined &&
          item.is_annotated_check == false
        )
          item.is_annotated_check = true;
        if (item.is_locked != undefined && item.is_locked == false)
          item.is_locked = true;
        if (item.is_annotated != undefined && item.is_annotated == false)
          item.is_annotated = true;
        lockedItem = item;
        return item;
      } else {
        return item;
      }
    });

    if (addLockedAIPathology(id, true)) {
      setTimeout(() => {
        setAddedAnnotation(temp);
      }, 10);

      handleUpdateAnnotationState(id, true);
    }
  };

  const checkIfAITagLocked = (id) => {
    let isLocked = false;
    for (let i = 0; i < addedAnnotation.length; i++) {
      const item = addedAnnotation[i];
      if (item.id === id) {
        isLocked = item.isAI && item.is_locked;
        break;
      }
    }
    return isLocked;
  }

  const handleAddingAnnotations = (pathology) => {
    if(cxrVersion && pathology != null && pathology != undefined && addedAnnotation?.some((item)=>item.id == pathology.id)){
      const updatedState1 = addedAnnotation.filter(
        (item) => item.id !== pathology.id
      );
      setAddedAnnotation(updatedState1);
      return;
    }
    if (!cxrVersion && pathology != null && pathology != undefined && pathology.ai_predicted) {
      const updatedState1 = addedAnnotation.filter(
        (item) => item.id !== pathology.id
      );
      setAddedAnnotation(updatedState1);
      return;
    }
    
    let result = ((pathology!= null && pathology != undefined) || !cxrVersion || annotationState.reportDoneStatus != 0) ? generateAnnotationsToDisplay(true, pathology) : [];
    let resultRevertFunc = generateAnnotationsToDisplay(false, pathology);
    handleDefaultGroupAndOptionsSelectionsBeforeSubmit(null, true);

    for (let i = 0; i < result.length; i++) {
      if (!testPatientViewer.hasOwnProperty(result[i].id)) {
        setTestPatientViewer({ ...testPatientViewer, [result[i].id]: [] });
      }
    }
    let unselectedPathology = [];
    let updatedResult = [];
    if (pathology != null && pathology != undefined) {
      unselectedPathology = addedAnnotation.filter(
        (item) => !item.is_locked && item.ai_predicted == 1
      );
      if (unselectedPathology != null && unselectedPathology.length > 0) {
        unselectedPathology.map((item1) => {
          if (!result.some((item2) => item1.id === item2.id)) {
            result.push(JSON.parse(JSON.stringify(item1)));
          }
        });
      }

      if(cxrVersion) { 
        result = result.filter(item => item.id == pathology.id);
      }

      updatedResult = result.map((item) => {
        if(cxrVersion) {
          return {...item, 
            is_annotated : true,
            is_locked : true,
            is_locked_check : true,
            is_annotation_check : true,
          }
        }
        // Check the value of is_lock
        if (item.is_locked === false) {
          // If is_lock is false, set is_annotation to false
          return { ...item, is_annotated: false };
        } else {
          // If is_lock is true, set is_annotation to true
          return { ...item, is_annotated: true };
        }
      });
    }
    if(cxrVersion) {
      updatedResult = [...addedAnnotation, ...updatedResult];
    }

    if (archivedPathology != null) {
      if (pathology != null && pathology != undefined) {
        updatedResult = updatedResult.filter((item1) => {
          return !archivedPathology.some((item2) => item1.id === item2.id);
        });
      } else {
        result = result.filter((item1) => {
          return !archivedPathology.some((item2) => item1.id === item2.id);
        });
      }
    }
    setAddedAnnotation(
      pathology != null && pathology != undefined ? updatedResult : result
    );
    setAddedStoreAnnotation(resultRevertFunc);
    parentAddedStoreAnnotationRef.current = resultRevertFunc;
    // Dedicated parent-only mirror of the above - unlike addedStoreAnnotation, this
    // is never repointed at a child/prior study, so ViewportState's one-shot parent
    // box-add effect stays correct even if it fires while a different study is active.
    setParentLockReference(resultRevertFunc);
    setAnnotationAddedSuccess(true);
    setAddedAnnotationLength(
      pathology != null && pathology != undefined
        ? updatedResult.length
        : result.length
    );
  };

  const handleDefaultGroupAndOptionsSelectionsBeforeSubmit = (
    bBoxCnt,
    defaultCheckForOption
  ) => {

    let annotation_stuff = annotationState.annotations_stuff;
    // let checkReset = annotationId != undefined && annotationId != null ? true : false;
    let checkReset = true;

    // iterate over all the annotations handed to us.
    for (let i = 0; i < annotation_stuff.length; i++) {
      let annotationObj = annotation_stuff[i];
      let id = annotationObj.id;
      if (
        (id > 40 && id != 56 && id != 58) ||
        (id == 28 && defaultCheckForOption)
      ) {
        continue;
      }

      // consider only selected or locked annotations
      if (
        //checkReset ? id == annotationId :
        annotationObj.is_present === 1 ||
        annotationObj.is_locked === true ||
        annotationObj.is_locked_check === true
      ) {
        // make sure that we have groups with options for this
        // annotation.
        // If we don't then there is no need to
        // proceed ahead

        if (annotationObj.group_numbers.length > 0) {
          // get all the selected groups

          let selectedGroups = annotationState.group_selections[id];

          if (selectedGroups === undefined || selectedGroups === null) {
            selectedGroups = [];
            //annotation_state.group_selections[id] = selectedGroups;
            setAnnotationState(() => {
              const newVal = { ...annotationState };
              newVal.group_selections[id] = selectedGroups;
              return newVal;
            });
            setAnnotationStateStore(() => {
              const newVal = { ...annotationStateStore };
              newVal.group_selections[id] = selectedGroups;
              return newVal;
            });
          }

          let annotationOptionSelections = annotationState.selections[id];

          if (
            annotationOptionSelections === undefined ||
            annotationOptionSelections === null
          ) {
            annotationOptionSelections = {};
            //annotation_state.selections[id] = annotationOptionSelections;
            setAnnotationState(() => {
              const newVal = { ...annotationState };
              newVal.selections[id] = annotationOptionSelections;
              return newVal;
            });
            setAnnotationStateStore(() => {
              const newVal = { ...annotationStateStore };
              newVal.selections[id] = annotationOptionSelections;
              return newVal;
            });
          }

          // make sure that the default group is always
          // considered.
          if (
            containsChecker(annotationObj.group_numbers, 0) &&
            !containsChecker(selectedGroups, 0) &&
            !checkReset
          ) {
            let defaultGroupDto =
              annotationObj.group_number_and_group_option_dto_map[0];
            defaultGroupDto.has_selections = 1;

            selectedGroups.push(0);
          }

          // now, if the above 'selected groups' is still 'zero'
          // then
          // we
          // need to select any arbitary group. Do this.
          if (selectedGroups.length === 0) {
            // Set group number for right here if user not choose
            // anything.
            var groupId = 0;
            if (annotationObj.name === "Nodule") {
              if (bBoxCnt != undefined && bBoxCnt != null && bBoxCnt[id] > 1) {
                groupId = 1;
              } else {
                groupId = 0;
              }
            }

            let firstGroupDto =
              annotationObj.group_number_and_group_option_dto_map[
                annotationObj.group_numbers[groupId]
              ];

            firstGroupDto.has_selections = 1;

            // add this dto to the above group
            selectedGroups.push(firstGroupDto.groupNumber);
          }

          // and now, get all the selected groups and make sure
          // that
          // at
          // least one suboption for the list of
          // options there, has been selected.
          for (let j = 0; j < selectedGroups.length; j++) {
            let groupNum = selectedGroups[j];

            let pathologyGroupAndOptionDTO =
              annotationObj.group_number_and_group_option_dto_map[groupNum];

            // all the options in the above group should have at
            // least
            // one selection.
            for (
              let k = 0;
              k < pathologyGroupAndOptionDTO.option_ids.length;
              k++
            ) {
              let option_id = pathologyGroupAndOptionDTO.option_ids[k];
              let optionObj =
                pathologyGroupAndOptionDTO
                  .option_id_and_option_suboption_dto_map[option_id];

              // mark this option to have selections
              //
              // We will be making some selections below for the option Object which do not have default selection.
              // if (optionObj.has_selected_suboption == 0) {
              optionObj.has_selected_suboption = 1;

              // get the list of selected suboptions from the
              // above
              // list
              let selectedSuboptions = annotationOptionSelections[option_id];

              if (
                selectedSuboptions === undefined ||
                selectedSuboptions === null
              ) {
                selectedSuboptions = [];
                annotationOptionSelections[option_id] = selectedSuboptions;
              }

              // make sure that the above list is non-empty
              // and if
              // it
              // is then add the first suboption to the
              // list of selections for this option.
              //
              // No need to do this for 'foreign body'
              if (
                selectedSuboptions.length === 0 &&
                annotationObj.name !== "ForeignBody"
              ) {
                let suboptionChosenForSelection = null;
                let suboptionObj = null;

                // search for a value which is 'no' or
                // 'without'. If
                // you find this then select that
                // suboption.
                for (
                  let index = 0;
                  index < optionObj.suboption_ids.length;
                  index++
                ) {
                  let suboptionId =
                    !checkVariable(annotationState.defaultSubOpts) &&
                    !checkVariable(annotationState.defaultSubOpts[optionObj.id])
                      ? annotationState.defaultSubOpts[optionObj.id][0]
                      : optionObj.suboption_ids[index];
                  let tempSuboptionObj =
                    optionObj.suboption_id_and_suboption_details_map[
                      suboptionId
                    ];

                  if (
                    tempSuboptionObj.name === "no" ||
                    tempSuboptionObj.name === "without"
                  ) {
                    suboptionChosenForSelection = suboptionId;
                    break;
                  }
                } // end of for

                if (suboptionChosenForSelection === null) {
                  if (
                    !checkVariable(annotationState.defaultSubOpts) &&
                    !checkVariable(
                      annotationState.defaultSubOpts[optionObj.id]
                    ) &&
                    annotationState.defaultSubOpts[optionObj.id] != null
                  ) {
                    //Default value found
                    suboptionChosenForSelection =
                      annotationState.defaultSubOpts[optionObj.id][0];
                  } else {
                    //Old logic
                    suboptionChosenForSelection = optionObj.suboption_ids[0];
                  }
                }

                suboptionObj =
                  optionObj.suboption_id_and_suboption_details_map[
                    suboptionChosenForSelection
                  ];
                suboptionObj.has_selected_suboption = 1;
                selectedSuboptions.push(suboptionChosenForSelection);
              }
              // } // end of for over the list of suboptions.
            } // end of for over the list of options
          } // end of for over the list of groups
        } // end of 'group numbers'
      } // end of of 'if' to check is 'annotations' are present.
    } // end of 'for'
  }; // end of 'handleDefaultGroupAndOptionsSelectionsBeforeSubmit'

  const getCountOfBoundingBox = () => {
    let annotationDataContainer = [];
    let count = 0;
    let bBoxArray = {};
    for (const key in annotationData) {
      for (const key2 in annotationData[key]) {
        if (annotationData[key][key2].length > 0) {
          bBoxArray[key2] = annotationData[key][key2].length;
        }
      }
    }
    return bBoxArray;
  };

  const getAnnotationUnsavedChanges = async () => {
    try {
      const activeViewport = await getViewport(activeViewportIndex);
      let annotationDataContainer = [];
      let countAnnotationMeasurements = 0;
      if (activeViewport != null) {
        Object.keys(annotationData).forEach((imageId, imageIdx) => {
          var newImageIdx = imageIdx;
          const dicomBaseURL = API_BASE_URL.startsWith("https")
            ? API_BASE_URL.replace("https", "dicomweb") +
              APIs.GETIMAGEDATA +
              imageId
            : API_BASE_URL.replace("http", "dicomweb") +
              APIs.GETIMAGEDATA +
              imageId;
          annotationDataContainer.push({
            name: "imageAnnotationMeasurements[" + newImageIdx + "].imageUrl",
            value: dicomBaseURL,
          });

          Object.keys(annotationData[imageId]).forEach((annotation, index) => {
            if (annotationData[imageId][annotation].length > 0) {
              annotationData[imageId][annotation].map((ele, index) => {
                const { imageData } = activeViewport?.getImageData();

                let updatedPoints = [];
                updatedPoints.push(
                  imageData.worldToIndex(ele.annotation.data.handles.points[0])
                );
                updatedPoints.push(
                  imageData.worldToIndex(ele.annotation.data.handles.points[1])
                );
                updatedPoints.push(
                  imageData.worldToIndex(ele.annotation.data.handles.points[2])
                );
                updatedPoints.push(
                  imageData.worldToIndex(ele.annotation.data.handles.points[3])
                );

                let updateJson = getCornerstoneLegacyJson(updatedPoints);
                annotationDataContainer.push({
                  name:
                    "imageAnnotationMeasurements[" +
                    newImageIdx +
                    "].annotationMeasurements[" +
                    index +
                    "].id",
                  value: parseInt(annotation),
                });
                annotationDataContainer.push({
                  name:
                    "imageAnnotationMeasurements[" +
                    newImageIdx +
                    "].annotationMeasurements[" +
                    index +
                    "].measurementData",
                  value: JSON.stringify(updateJson),
                });
              });
            }
          });
        });
        return { loaded: true, data: annotationDataContainer };
      }
    } catch (e) {
      return { loaded: true, data: null };
    }
  };

  const submitSelectedOptions = async (state) => {
    if (state) {
      setEnableReportRegenerate(false);
    }
    // Ignored Bboxarray related changes

    let bBoxArray1 = {};
    bBoxArray1 = getCountOfBoundingBox();

    let bBoxData = [];
    bBoxData = await getAnnotationUnsavedChanges();

    //   [
    //     {
    //         "name": "imageAnnotationMeasurements[0].imageUrl",
    //         "value": "dicomweb://localhost:45451/study/api/image/get/southbuck/THUMB/FTunitiaHVZu2iETf/FTunitiaHVZu2iETf_518_924_15363_triageIssue.dcm"
    //     },
    //     {
    //         "name": "imageAnnotationMeasurements[0].annotationMeasurements[0].id",
    //         "value": 2
    //     },
    //     {
    //         "name": "imageAnnotationMeasurements[0].annotationMeasurements[0].measurementData",
    //         "value": "{\"measurementId\":-1,\"status\":\"upd\",\"visible\":true,\"active\":false,\"invalidated\":false,\"color\":\"#3cb44b\",\"handles\":{\"start\":{\"x\":67.88950276243094,\"y\":323.5359116022099,\"highlight\":true,\"active\":false},\"end\":{\"x\":263.07182320441984,\"y\":496.4419889502762,\"highlight\":true,\"active\":false},\"textBox\":{\"active\":false,\"hasMoved\":false,\"movesIndependently\":false,\"drawnIndependently\":true,\"allowedOutsideImage\":true,\"hasBoundingBox\":true}},\"annotationId\":2,\"meanStdDev\":{\"count\":33908,\"mean\":9801.55624041524,\"variance\":243060.66243216395,\"stdDev\":493.01182788262184},\"area\":5953.184137334025,\"unit\":\"mm²\"}"
    //     },
    //     {
    //         "name": "imageAnnotationMeasurements[0].annotationMeasurements[1].id",
    //         "value": 2
    //     },
    //     {
    //         "name": "imageAnnotationMeasurements[0].annotationMeasurements[1].measurementData",
    //         "value": "{\"measurementId\":-1,\"status\":\"upd\",\"visible\":true,\"active\":false,\"invalidated\":false,\"color\":\"#3cb44b\",\"handles\":{\"start\":{\"x\":112.44198895027625,\"y\":369.1491712707182,\"highlight\":true,\"active\":false},\"end\":{\"x\":241.8563535911602,\"y\":472.0441988950276,\"highlight\":true,\"active\":false},\"textBox\":{\"active\":false,\"hasMoved\":false,\"movesIndependently\":false,\"drawnIndependently\":true,\"allowedOutsideImage\":true,\"hasBoundingBox\":true}},\"annotationId\":2,\"meanStdDev\":{\"count\":13390,\"mean\":9648.226736370425,\"variance\":193990.85075642169,\"stdDev\":440.4439246446949},\"area\":2348.959091798174,\"unit\":\"mm²\"}"
    //     }
    // ];
    if (bBoxData.loaded == true) {
      handleDefaultGroupAndOptionsSelectionsBeforeSubmit(bBoxArray1, true);
      // get the string representations of the selections
      let annotations = JSON.stringify(getAllSelectedAnnotation());
      let groups_json = JSON.stringify(annotationState.group_selections);
      let options_json = JSON.stringify(annotationState.selections);

      let numberSort = function (a, b) {
        return a - b;
      };

      let allAnnotations = JSON.parse(annotations).sort(numberSort);
      let allGroup_json = JSON.parse(groups_json);
      let allOptions_json = JSON.parse(options_json);

      let stuff = annotationState.annotations_stuff;
      let oldAnnotations = [];
      let newAnnotations = [];

      let oldGroup_json = {};
      let newGroup_json = {};

      let oldOptions_json = {};
      let newOptions_json = {};

      var callAjax = true;

      for (let i = 0; i < allAnnotations.length; i++) {
        for (let j = 0; j < stuff.length; j++) {
          // if(allAnnotations[i] === stuff[j].id && allAnnotations[i] !==
          // 39)
          if (allAnnotations[i] === stuff[j].id) {
            if (stuff[j].version === 0) {
              oldAnnotations.push(allAnnotations[i]);
              oldGroup_json[allAnnotations[i]] =
                allGroup_json[allAnnotations[i]];
              oldOptions_json[allAnnotations[i]] =
                allOptions_json[allAnnotations[i]];
            } else {
              newAnnotations.push(allAnnotations[i]);
              newGroup_json[allAnnotations[i]] =
                allGroup_json[allAnnotations[i]];
              newOptions_json[allAnnotations[i]] =
                allOptions_json[allAnnotations[i]];
            }
          }
        }
      }

      var url_string = "";
      var final_annotations = [];
      var final_groups_json = {};
      var final_options_json = {};

      if (oldAnnotations.length === 0 && newAnnotations.length !== 0) {
        url_string = "/study/options/api/temporary-report-new-annotation";
        final_annotations = newAnnotations;
        final_groups_json = newGroup_json;
        final_options_json = newOptions_json;
      }
      if (oldAnnotations.length !== 0 && newAnnotations.length === 0) {
        url_string = "/study/options/api/temporary-report";
        final_annotations = oldAnnotations;
        final_groups_json = oldGroup_json;
        final_options_json = oldOptions_json;
      }

      // overwrite hidden input fields with the above values, so that,
      // when
      // 'save'
      // or 'submit' is clicked, these values
      // get submitted to the server.
      // $("#finalreport_annotations_json").val(JSON.stringify(final_annotations));
      // $("#finalreport_studyoptions_json").val(JSON.stringify(final_options_json));
      let chosenSelection = {};
      let chosenAnnotation = annotationState.selections;
      let chosenAnnotationKeys = Object.keys(annotationState.selections);

      for (let i = 0; i < chosenAnnotationKeys.length; i++) {
        let annId = chosenAnnotationKeys[i];
        let nonZeroOption = {};
        let optionKeys = Object.keys(annotationState.selections[annId]);
        for (let j = 0; j < optionKeys.length; j++) {
          let optId = optionKeys[j];
          let optionObj = chosenAnnotation[annId][optId];
          if (chosenAnnotation[annId][optId].length > 0) {
            nonZeroOption[optId] = optionObj;
          }
        }

        chosenSelection[annId] = nonZeroOption;
      }

      // let chosenSelection = annotation_state.selections;
      let AllchosenGroup = annotationState.group_selections;
      let ann = annotationState.annotations_stuff;

      let final_res = {};
      if (Object.keys(JSON.parse(annotations)).length !== 0) {
        for (let i = 0; i < ann.length; i++) {
          if (
            ann[i].is_present === 1 &&
            (ann[i].is_locked === true || ann[i].is_locked_check === true)
          ) {
            let annotation_result = [];
            let annObj = ann[i];
            let annName = annObj.name;
            let annId = annObj.id;
            let chosenGroup = AllchosenGroup[annId];
            let realGroupKeys = annObj.group_numbers;
            // (chosenGroup === undefined || chosenGroup === null) &&
            // (Object.keys(annotation_state.selections).length === 0)
            if (chosenGroup === undefined || chosenGroup === null) {
              for (let d = 0; d < realGroupKeys.length; d++) {
                let gNum = realGroupKeys[d];
                let parentGroupObj = {};
                parentGroupObj.groupId = gNum;
                parentGroupObj.groupName =
                  annObj.group_number_and_group_option_dto_map[gNum].name;
                parentGroupObj.oAndso = {};
                annotation_result.push(parentGroupObj);
              }
            } else {
              for (let d = 0; d < realGroupKeys.length; d++) {
                let gNum = realGroupKeys[d];
                if (!chosenGroup.includes(gNum)) {
                  let groupNum = realGroupKeys[d];

                  let parentGroupObj = {};
                  parentGroupObj.groupId = gNum;
                  parentGroupObj.groupName =
                    annObj.group_number_and_group_option_dto_map[gNum].name;
                  parentGroupObj.oAndso = {};
                  annotation_result.push(parentGroupObj);
                } else {
                  if (chosenSelection[annId] == undefined) {
                    continue;
                  }
                  let groupNum = realGroupKeys[d];
                  let parentGroupObj = {};

                  let grpObj =
                    annObj.group_number_and_group_option_dto_map[groupNum];

                  parentGroupObj.groupId = groupNum;
                  parentGroupObj.groupName = grpObj.name;
                  parentGroupObj.oAndso = {};

                  let optionKeys = Object.keys(chosenSelection[annId]);
                  let realOptionsKeys = Object.keys(
                    annObj.group_number_and_group_option_dto_map[groupNum]
                      .option_id_and_option_suboption_dto_map
                  );
                  for (let k = 0; k < optionKeys.length; k++) {
                    for (let x = 0; x < realOptionsKeys.length; x++) {
                      if (optionKeys[k] === realOptionsKeys[x]) {
                        let optionNum = optionKeys[k];
                        let optionObj =
                          grpObj.option_id_and_option_suboption_dto_map[
                            optionNum
                          ];
                        let optionName = optionObj.name;
                        let chosenSuboptions =
                          chosenSelection[annId][optionNum];
                        let subOptionArray = [];
                        for (let l = 0; l < chosenSuboptions.length; l++) {
                          let suboptionNum = chosenSuboptions[l];
                          let suboptionObj =
                            optionObj.suboption_id_and_suboption_details_map[
                              suboptionNum
                            ];
                          // name_suboption = suboptionObj.name;
                          subOptionArray.push(suboptionObj.name);
                        }
                        parentGroupObj.oAndso[optionName] = subOptionArray;
                      }
                    }
                  }
                  annotation_result.push(parentGroupObj);
                }
              }
            } // latest if
            final_res[annName] = annotation_result;
          }
        }
      }
      if (Object.keys(JSON.parse(annotations)).length === 0) {
        let final_res_string =
          '{"Left Knee":[{"groupId":1,"groupName":"Bone Density","oAndso":{}},{"groupId":2,"groupName":"Osteophytes Abnormal","oAndso":{}},{"groupId":3,"groupName":"Joint Space Reduction","oAndso":{}},{"groupId":4,"groupName":"Enthesophytes","oAndso":{}},{"groupId":5,"groupName":"Bursa","oAndso":{}}],"Right Knee":[{"groupId":1,"groupName":"Bone Density","oAndso":{}},{"groupId":2,"groupName":"Osteophytes Abnormal","oAndso":{}},{"groupId":3,"groupName":"Joint Space Reduction","oAndso":{}},{"groupId":4,"groupName":"Enthesophytes","oAndso":{}},{"groupId":5,"groupName":"Bursa","oAndso":{}}]}';
        final_res = JSON.parse(final_res_string);
      }

      // const annotationForm = $("form[name='form_annotation']");
      // let annotationData = annotationForm.serializeArray();
      let annotationDataCustom = [];

      var validationResult = validateSpine(annotationState.selections);
      if (validationResult != null) {
        //showAlert(validationResult.message, function() { });
        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = validationResult.message;
          return newItem;
        });
        //_unblockUI();
        return false;
      }

      var extraData = {};
      let gfLocation = "";
      let gfBodyPart = "";
      if (annotationState.extra_value["general-fracture"] != undefined) {
        if (
          annotationState.extra_value["general-fracture"]["txtLocation"] !=
          undefined
        ) {
          gfLocation =
            annotationState.extra_value["general-fracture"]["txtLocation"][0];
        }
        if (
          annotationState.extra_value["general-fracture"]["selectBodypart"] !=
            undefined &&
          annotationState.extra_value["general-fracture"]["selectBodypart"] !=
            ""
        ) {
          gfBodyPart =
            annotationState.extra_value["general-fracture"][
              "selectBodypart"
            ][0];
        } else {
          gfBodyPart = "Ankle";
        }
      }
      extraData["general-fracture"] = getExtraFieldJson(gfLocation, gfBodyPart);
      //Need to add pixelSpacing
      //let pixelSpacing = getRowColumnPixelSpacing();
      //extraData["pixel-spacing"] = pixelSpacing;
      /*extraData['row-pixelSpacing'] = pixelSpacing['rowPixelSpacing']*/

      // setAnnotationState(() => {
      //   const newVal = { ...annotationState };
      //   newVal.extra_value = extraData;
      //   return newVal;
      // });

      validationResult = validateGeneralFractureAnnotation(
        annotationState.selections,
        getAllSelectedAnnotation(),
        JSON.parse(JSON.stringify(general_fracture_validation_data)),
        gfLocation,
        gfBodyPart
      );

      if (validationResult != null) {
        // showAlert(validationResult.message, function() { });

        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = validationResult.message;
          return newItem;
        });

        //    	_unblockUI();
        return false;
      }

      validationResult = validateCovidSuspectAnnotation(
        annotationState.selections,
        getAllSelectedAnnotation(),
        annotationState.group_selections,
        JSON.parse(JSON.stringify(covid_suspect_validation_data))
      );
      if (validationResult != null) {
        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = validationResult.message;
          return newItem;
        });
        return false;
      }

      let locked_selections = {};
      let keys = Object.keys(annotationState.selections);
      keys.forEach((key) => {
        let annotation = getAnnotationData(parseInt(key));
        if (
          annotation.is_locked == true ||
          annotation.is_locked_check == true
        ) {
          locked_selections[key] = annotationState.selections[key];
        }
      });
      setStudyOptionJson(JSON.stringify(locked_selections));
      annotationDataCustom.push({
        name: "studyOptionsJson",
        value: JSON.stringify(locked_selections),
      });
      annotationDataCustom.push({
        name: "annotationsJson",
        value: JSON.stringify(getAllSelectedAnnotation()),
      });
      let locked_groups = {};
      keys = Object.keys(annotationState.group_selections);
      keys.forEach((key) => {
        let annotation = getAnnotationData(parseInt(key));
        if (
          annotation.is_locked == true ||
          annotation.is_locked_check == true
        ) {
          locked_groups[key] = annotationState.group_selections[key];
        }
      });
      annotationDataCustom.push({
        name: "groupsJson",
        value: JSON.stringify(locked_groups),
      });
      annotationDataCustom.push({
        name: "resultJson",
        value: JSON.stringify(final_res),
      });
      let bBoxCount = getBoundingBoxCount();
      annotationDataCustom.push({
        name: "bBoxCount",
        value: JSON.stringify(bBoxArray1),
      });

      annotationDataCustom.push({
        name: "extraValue",
        value: JSON.stringify(extraData),
      });

      annotationDataCustom.push({
        name: "bbMeasurementData",
        value: JSON.stringify(bBoxData.data),
      });
      regenerateReportData(annotationDataCustom);
    }
  };

  const getBoundingBoxCount = () => {
    let data = {};
    for (const image in annotationData) {
      for (const annotation in annotationData[image]) {
        if (annotationData[image] != undefined) {
          if (annotationData[image][annotation].length > 0) {
            let num = annotationData[image][annotation].length;
            if (!data[annotation]) {
              data[annotation] = num;
            }
          }
        }
      }
    }
    return data;
  };

  const getComparisionString = () => {
    let compareString = "";
    if (parentChildReportsObj && Object.keys(parentChildReportsObj).length > 0) {

      let tempParentObj = { ...parentChildReportsObj };
      if (parentChildReportsObj.hasOwnProperty(studyParentId)) {
        delete tempParentObj[studyParentId];
      } else {

      }
      const objArray = Object.values(tempParentObj);
      objArray.sort((a, b) =>
        Moment(b.uploadDateDisplay, "DD-MMM-YY HH:mm").valueOf() -
        Moment(a.uploadDateDisplay, "DD-MMM-YY HH:mm").valueOf()
      );

      objArray.forEach((key, index) => {
        compareString += objArray[index].modality + " " +
          Moment(objArray[index].studyDateDisplay, "DD-MMM-YY HH:mm")
          .format("DD-MMM YYYY")
          .toUpperCase();
      
        if (index < objArray.length - 1) {
          compareString += ", ";
        }
      });
    }
    return compareString;
  }

  const regenerateReportData = async (body) => {
    setLoaderRunning(true);

    ref.current.continuousStart();
    const comparisonString = getComparisionString();
    let inputData = {
      dto: {
        studyId: studyParentId,
        studyOptionsJson: body[0].value,
        annotationsJson: body[1].value,
        groupsJson: body[2].value,
        resultJson: body[3].value,
        bBoxCount: body[4].value,
        extraValue: body[5].value,
        bbMeasurementData: body[6].value,
        aiSuboptions: null,
        comparisionText: comparisonString != ""?comparisonString : null
      },
    };
    // setShowToast((prev) => {
    //   return { ...prev, show: false, message: "", loading:true,state:"success" };
    // });
    let res = await regenerateReport(inputData);
    if (res.data.result == "SUCCESS") {
      regenerateSmartReport(res.data?.data?.data?.study_report_info);
      try {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.SUCCESS, "Regenerated Report Successfully");
        setSubmitComplete(true);
        // setShowToast((prev) => {
        //   return { ...prev, show: true, message: "Regenerated Report Successfully", loading:false,state:"success" };
        // });
      } catch (e) {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, e.message);
        // setShowToast((prev) => {
        //   return { ...prev, show: true, message: e.message, loading:false,state:"error" };
        // });
      }

      /*let result = res.data?.data?.data?.study_report_info;
    let opt = [];
      let allAddedTabs = patientReports.filter((ele,index)=>{
        if(!ele.text.includes("Auto")){
          return ele;
        }
      });
      setPatientReports(allAddedTabs);

      if(res.data.data?.data?.study_report_info.length > 0){
        allAddedTabs.push({
          key: result[0].reportTemplateId,
          text: result[0].reportTemplateTitle,
          isSuperSpecialReport: result[0].isSuperSpecialReport,
          reportDetails: result[0],
        });
        setPatientReports(allAddedTabs);

        let temp = allAddedTabs.filter((ele,ind)=>{
          if(ele.text.includes("Auto") || ele.text.includes("General")){
            return ele;
          }
        })

        handleChangeTemplate(temp[0]);*/

      //}
    } else {
      //alert("Error while in creating smart report");
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, "Error while regenerating report");
    }
  };

  const checkVariable = (variable) => {
    if (typeof variable === "undefined" || variable === null) {
      return true;
    } 
    return false;
  };

  useEffect(() => {
    handleAnnotationJsonData(addedAnnotation);
  }, [addedAnnotation]);

  const checkForUnLockPathology = () => {
    let annotation_stuff = annotationState.annotations_stuff;
    
    let annotationObjs = [];
    let archivedAnnotationObjs = [];

    for (let i = 0; i < annotation_stuff.length; i++) {
      if (annotation_stuff[i].is_present === 1) {
        let remove_annotation = false;
        if (
          ((annotation_stuff[i].is_locked != true &&
            annotation_stuff[i].is_locked != undefined) ||
            (annotation_stuff[i].is_locked_check != undefined &&
              annotation_stuff[i].is_locked_check != true)) &&
          annotation_stuff[i].ai_predicted == 1
        ) {
          if (annotation_stuff[i].is_annotated == true) {
            annotation_stuff[i].is_annotated = false;
          }
          if (annotation_stuff[i].is_annotated_check == true) {
            annotation_stuff[i].is_annotated_check = false;
          }
          remove_annotation = true;
        }
        let annotationObj = {};

        annotationObj.id = annotation_stuff[i].id;
        annotationObj.name = annotation_stuff[i].name;
        annotationObj.color = annotation_stuff[i].colour;
        annotationObj.sequence_num = annotation_stuff[i].sequence_num;
        annotationObj.corrPathPrediction =
          annotation_stuff[i].corrPathPrediction;
        annotationObj.is_locked = remove_annotation
          ? false
          : annotation_stuff[i].is_locked_check;
        annotationObj.is_annotated = remove_annotation
          ? false
          : annotation_stuff[i].is_annotation_check;
        annotationObj.isActive = annotation_stuff[i].isActive;
        annotationObj.viewed = annotation_stuff[i].viewed;
        annotationObj.isAI = annotation_stuff[i].isAI;
        annotationObj.isAIEdited = annotation_stuff[i].isAIEdited;
        annotationObj.ai_predicted = annotation_stuff[i].ai_predicted;
        annotationObj.is_selected = annotation_stuff[i].is_selected;

        if (!remove_annotation) {
          annotationObjs.push(annotationObj);
        } else if (remove_annotation && annotationObj.ai_predicted == 1) {
          archivedAnnotationObjs.push(annotationObj);
        }
      }
    }
    for (let i = 0; i < annotationObjs.length; i++) {
      for (let j = 0; j < annotationObjs.length - 1 - i; j++) {
        if (
          annotationObjs[j].sequence_num > annotationObjs[j + 1].sequence_num
        ) {
          let temp = annotationObjs[j];
          annotationObjs[j] = annotationObjs[j + 1];
          annotationObjs[j + 1] = temp;
        }
      }
    }

    setAnnotationState(() => {
      const newItem = { ...annotationState };
      newItem.annotations_stuff = annotation_stuff;
      return newItem;
    });

    if (archivedPathology != null) {
      setArchivedPathology(archivedAnnotationObjs);
    }
    return annotationObjs;
  };

  const generateAnnotationsToDisplay = (checkForRevert, pathology) => {
    let annotation_stuff = annotationState.annotations_stuff;
    let Temp = JSON.parse(JSON.stringify(annotationState.annotations_stuff));
    let annotationObjs = [];
    let archivedAnnotationObjs = [];

    for (let i = 0; i < annotation_stuff.length; i++) {
      if (annotation_stuff[i].is_present === 1) {
        let remove_annotation = false;
        if (
          !annotation_stuff[i].is_locked_check &&
          !annotation_stuff[i].is_annotation_check
        ) {
          if (
            annotationState.reportDoneStatus == 1 ||
            annotationState.reportDoneStatus == 2 ||
            reportSavedBy > 0 ||
            annotationState.expReviewDoneStatus
            // || (annotationState.reportSavedBy != 0 && annotationState.reportSavedBy != null)
          ) {
            if (
              annotation_stuff[i].ai_predicted &&
              annotation_stuff[i].is_selected
            ) {
              annotation_stuff[i].is_locked_check = true;
              annotation_stuff[i].is_annotation_check = true;
              annotation_stuff[i].isAI = true;
            } else if (
              annotation_stuff[i].ai_predicted &&
              !annotation_stuff[i].is_selected
            ) {
              if (!roles.includes(USERTYPES.SUPERVISOR)) {
                if (!checkForRevert) {
                  annotation_stuff[i].is_locked_check = false;
                  annotation_stuff[i].is_annotation_check = false;
                  annotation_stuff[i].isAI = true;
                } else {
                  remove_annotation = true;
                }
              }
            } else if (annotation_stuff[i].ai_predicted) {
              annotation_stuff[i].is_locked_check = false;
              annotation_stuff[i].is_annotation_check = false;
              annotation_stuff[i].isAI = false;
            } else {
              annotation_stuff[i].is_locked_check = true;
              annotation_stuff[i].is_annotation_check = true;
              annotation_stuff[i].isAI = true;
            }
          } else if (annotationState.reportDoneStatus == 0) {
            if (roles.includes(USERTYPES.RADIOLOGIST)) {
              if (
                autoGenerateReportData.aiProcessed != null &&
                autoGenerateReportData.maxAIEmergency != null &&
                autoGenerateReportData.aiProcessed == 1 &&
                autoGenerateReportData.maxAIEmergency == 6
              ) {
                if ((!cxrVersion || !enableLlmReport) && reportSavedBy == 0) {
                  annotation_stuff[i].is_locked_check = true;
                }
              } else {
                annotation_stuff[i].is_locked_check = false;
                annotation_stuff[i].is_annotation_check = false;
                annotation_stuff[i].isAI = true;
              }
            } else {
              annotation_stuff[i].is_locked_check = false;
              annotation_stuff[i].is_annotation_check = false;
              annotation_stuff[i].isAI = true;
            }
          }
          // else{
          //   annotation_stuff[i].isAI = true;
          // }
        }
        let annotationObj = {};

        annotationObj.id = annotation_stuff[i].id;
        annotationObj.name = annotation_stuff[i].name;
        annotationObj.color = annotation_stuff[i].colour;
        annotationObj.sequence_num = annotation_stuff[i].sequence_num;
        annotationObj.corrPathPrediction =
          annotation_stuff[i].corrPathPrediction;
        annotationObj.is_locked = annotation_stuff[i].is_locked_check;
        annotationObj.is_annotated = annotation_stuff[i].is_annotation_check;
        annotationObj.isActive = annotation_stuff[i].isActive;
        annotationObj.viewed = annotation_stuff[i].viewed;
        annotationObj.isAI = annotation_stuff[i].isAI;
        annotationObj.isAIEdited = annotation_stuff[i].isAIEdited;
        annotationObj.ai_predicted = annotation_stuff[i].ai_predicted;
        annotationObj.is_selected = annotation_stuff[i].is_selected;
        if (!remove_annotation) {
          annotationObjs.push(annotationObj);
        } else {
          archivedAnnotationObjs.push(annotationObj);
        }
        //annotationObjs.push(annotationObj);
      }
    }
    for (let i = 0; i < annotationObjs.length; i++) {
      for (let j = 0; j < annotationObjs.length - 1 - i; j++) {
        if (
          annotationObjs[j].sequence_num > annotationObjs[j + 1].sequence_num
        ) {
          let temp = annotationObjs[j];
          annotationObjs[j] = annotationObjs[j + 1];
          annotationObjs[j + 1] = temp;
        }
      }
    }

    setAnnotationState(() => {
      const newItem = { ...annotationState };
      newItem.annotations_stuff = annotation_stuff;
      return newItem;
    });
    if (checkForRevert && archivedPathology == null) {
      setArchivedPathology(archivedAnnotationObjs);
    }
    // return pathology != null && pathology != undefined ? annotationObjs : [];
    return annotationObjs;
  };

  const addOrRemoveAnnotation = (selectedAnnotationId, shouldAdd, autoLock, bbMode) => {
    setEnableReportRegenerate(true);
    let tempAnnotationState = annotationState.annotations_stuff;
    let newlyAddedPathalogy = null;
    let deletedPathalogy = null;

    if (shouldAdd) {
      if (
        archivedPathology?.some((item2) => selectedAnnotationId === item2.id)
      ) {
        const archivedAlreadyPathology = archivedPathology.filter(
          (item) => item.id === selectedAnnotationId
        );
        if (archivedAlreadyPathology.length > 0) {
          handleMovePathologyArchived(
            archivedAlreadyPathology[0],
            false,
            autoLock
          );
          let data = {
            id: archivedAlreadyPathology[0].id,
            backgroundColor: archivedAlreadyPathology[0].color,
            pathalogyName: archivedAlreadyPathology[0].name,
          };
          handlePencilClick(data, "RectangleROI");
          setBoundingBoxMode(bbMode);
          handleDefaultToolChange();
        }

        return;
      }
    }

    for (let i = 0; i < tempAnnotationState.length; i++) {
      let annotationObj = tempAnnotationState[i];
      let id = annotationObj.id;

      if (id === selectedAnnotationId) {
        if (shouldAdd) {
          annotationObj.is_present = 1;
          if (
            annotationObj.is_annotation_check == undefined ||
            annotationObj.is_annotation_check == null
          ) {
            annotationObj["is_annotation_check"] = true;
          } else {
            annotationObj.is_annotation_check = true;
          }

          if (
            annotationObj.is_locked == undefined ||
            annotationObj.is_locked == null
          ) {
            annotationObj["is_locked"] = true;
          } else {
            annotationObj.is_locked = true;
          }

          if (
            annotationObj.is_annotation == undefined ||
            annotationObj.is_annotation == null
          ) {
            annotationObj["is_annotation"] = true;
          } else {
            annotationObj.is_annotation = true;
          }
          if (
            annotationObj.is_locked_check == undefined ||
            annotationObj.is_locked_check == null
          ) {
            annotationObj["is_locked_check"] = true;
          } else {
            annotationObj.is_locked_check = true;
          }
          annotationObj["isAI"] = false;
          annotationObj.sequence_num = ++annotationState.sequence_num;

          if (
            annotationObj.viewed != null ||
            annotationObj.viewed != undefined
          ) {
            annotationObj["viewed"] = annotationObj.viewed;
          }

          newlyAddedPathalogy = annotationObj;
          let temp = testPatientViewer;
        } else {
          deletedPathalogy = annotationObj;
          annotationObj.is_present = 0;
          annotationObj.is_selected = 0;
          annotationObj["is_annotated"] = false;
          annotationObj["is_locked"] = false;
          if (
            annotationObj.is_annotation == undefined ||
            annotationObj.is_annotation == null
          ) {
            annotationObj["is_annotation"] = false;
          } else {
            annotationObj.is_annotation = false;
          }
          if (
            annotationObj.is_locked_check == undefined ||
            annotationObj.is_locked_check == null
          ) {
            annotationObj["is_locked_check"] = false;
          } else {
            annotationObj.is_locked_check = false;
          }
          annotationObj["viewed"] = false;
          annotationObj.sequence_num = 0;
          if (selectedAnnotationId === 54) {
          }
        }
      }
      tempAnnotationState[i] = annotationObj;
    }

    if (
      addedAnnotation != undefined &&
      newlyAddedPathalogy != null &&
      !disablePenEye
    ) {
      if(cxrVersion && newlyAddedPathalogy?.ai_predicted  ){
        // skipping for AI predicted new added pathology for analyzer
        handleDefaultToolChange(); 
      }else{
        let data = {
          id: newlyAddedPathalogy.id,
          backgroundColor: newlyAddedPathalogy.colour,
          pathalogyName: newlyAddedPathalogy.name,
        };
        handlePencilClick(data, "RectangleROI");
        setBoundingBoxMode(bbMode);
          
        setTimeout(() => {
          let tempActiveTool = JSON.parse(JSON.stringify(activeTool));
          if(tempActiveTool !== "RectangleROI"){
            setPreviousActiveTool(tempActiveTool);
            setActiveTool("RectangleROI");
          }
          setEditWarning(() => {
            let newVal = { ...editWarning };
            newVal.show = true;
            newVal.success = false;
            newVal.name = newlyAddedPathalogy.name;
            newVal.color = newlyAddedPathalogy.colour;
            return newVal;
          });
        }, 100);
        
        setDisableAddPathology(true);
      }
      
    } else {
      if (deletedPathalogy?.ai_predicted) {
        handleMovePathologyArchived(
          JSON.parse(JSON.stringify(deletedPathalogy)),
          true
        );
      }

      setPreviousActiveTool("RectangleROI");
      handleDefaultToolChange();
      // setActiveTool(StackScrollTool.toolName);
      if(deletedPathalogy)
        handleDeleteSmartTag(deletedPathalogy);
      setDisableAddPathology(false);
      setEditWarning(() => {
        let newVal = { ...editWarning };
        newVal.show = false;
        newVal.success = false;
        newVal.name = "";
        newVal.color = "";
        return newVal;
      });
    }
    setAnnotationState(() => {
      const newVal = { ...annotationState };
      newVal.annotations_stuff = tempAnnotationState;
      return newVal;
    });
    getStudyAnnotation(
      deletedPathalogy == null ? newlyAddedPathalogy : deletedPathalogy
    );
    setSearchInputValue("");
    if (deletedPathalogy?.ai_predicted) {
      return;
    }
    getFilteredAnnotationList(tempAnnotationState);
  };

  const createAnnotationJson = () => {
    let annotations = JSON.stringify(getAllSelectedAnnotation());
    let locked_groups = {};
    let keys = Object.keys(annotationState.group_selections);
    keys.forEach((key) => {
      let annotation = getAnnotationData(parseInt(key));
      if (annotation.is_locked == true) {
        locked_groups[key] = annotationState.group_selections[key];
      }
    });
    let groups_json = JSON.stringify(locked_groups);
    let locked_selections = {};
    keys = Object.keys(annotationState.selections);
    keys.forEach((key) => {
      let annotation = getAnnotationData(parseInt(key));
      if (annotation.is_locked == true) {
        locked_selections[key] = annotationState.selections[key];
      }
    });
    setStudyOptionJson(JSON.stringify(locked_selections));
    setAnnotationsJson(JSON.stringify(annotations));
  };

  const getAllSelectedAnnotation = () => {
    let selected_annotations = [];

    let selected_annotation_seq_num_map = {};

    let annotation_stuff = annotationState.annotations_stuff;

    for (let i = 0; i < annotation_stuff.length; i++) {
      let annotationObj = annotation_stuff[i];
      let id = annotationObj.id;

      if (
        annotationObj.is_present === 1 &&
        (annotationObj.is_locked === true ||
          annotationObj.is_locked_check == true)
      ) {
        selected_annotations.push(id);
        selected_annotation_seq_num_map[id] = annotationObj.sequence_num;
      }
    }
    for (let i = 0; i < selected_annotations.length; i++) {
      for (let j = 0; j < selected_annotations.length - 1 - i; j++) {
        let seq_num_1 =
          selected_annotation_seq_num_map[selected_annotations[j]];
        let seq_num_2 =
          selected_annotation_seq_num_map[selected_annotations[j + 1]];

        if (seq_num_1 > seq_num_2) {
          let temp = selected_annotations[j];
          selected_annotations[j] = selected_annotations[j + 1];
          selected_annotations[j + 1] = temp;
        }
      }
    }

    return selected_annotations.sort();
  };

  const getAnnotationData = (annotationId) => {
    for (let i = 0; i < annotationState.annotations_stuff.length; i++) {
      if (annotationState.annotations_stuff[i].id === annotationId) {
        return annotationState.annotations_stuff[i];
      }
    }
  };

  const getListOfGroups = (annotationData) => {
    // the list which we will be returning
    let listOfGroups = [];

    let groupNumbers = annotationData.group_numbers;

    for (let i = 0; i < groupNumbers.length; i++) {
      let groupNum = groupNumbers[i];

      let groupData =
        annotationData.group_number_and_group_option_dto_map[groupNum];
      listOfGroups.push(groupData);
    }

    return listOfGroups;
  }; // end of 'getListOfGroups'

  const containsChecker = (list, value) => {
    let returnValue = false;

    if (list === undefined || list === null) {
      returnValue = false;
    } else {
      for (let i = 0; i < list.length; i++) {
        if (list[i] === value) {
          returnValue = true;
          break;
        }
      } // end of 'for'
    }

    return returnValue;
  }; // end of 'contains'

  const removeFromArray = (arr, item) => {
    if (arr !== undefined && arr.length > 0) {
      let index = arr.indexOf(item);

      if (index > -1) {
        arr.splice(index, 1);
      }
    }
  };

  const handleCheckTab = (index, annotationId, groupObj, event) => {
    let isChecked = event.target.checked;
    if (!isChecked) {
      let groupSelectionsArr = annotationState.group_selections[annotationId];
      let annotationSelectionObj = annotationState.selections[annotationId];
      removeFromArray(groupSelectionsArr, groupObj.groupNumber);
      setAnnotationState(() => {
        const newVal = { ...annotationState };
        newVal.group_selections[annotationId] = groupSelectionsArr;
        // newVal.selections[annotationId] = {};
        return newVal;
      });

      if (groupSelectionsArr.length === 0) {
        // delete annotation_state.group_selections[annotationId];
        //Need to remove it
        setAnnotationState(() => {
          const newVal = { ...annotationState };
          newVal.group_selections[annotationId] = [];
          return newVal;
        });
      }
    } else {
      let groupSelectionsArr = annotationState.group_selections[annotationId];
      let tempAnnotationState = annotationState.group_selections;
      if (groupSelectionsArr === undefined || groupSelectionsArr === null) {
        groupSelectionsArr = [];
        // annotation_state.group_selections[annotationId] = groupSelectionsArr;
        tempAnnotationState[annotationId] = groupSelectionsArr;
      }
      if (!groupSelectionsArr.includes(groupObj.groupNumber)) {
        groupSelectionsArr.push(groupObj.groupNumber);
      }
      // tempAnnotationState[annotationId] = groupSelectionsArr;
      setAnnotationState(() => {
        const newVal = { ...annotationState };
        newVal.group_selections = tempAnnotationState;
        return newVal;
      });
    }
  };

  const getMaxSuboptions = (annotationObj, option_ids) => {
    let maxSuboptions = 0;

    if (option_ids != undefined)
      for (let i = 0; i < option_ids.length; i++) {
        let option_id = option_ids[i];

        let numOfSuboptions =
          annotationObj.option_id_and_option_suboption_dto_map[option_id]
            .suboption_ids.length;

        if (maxSuboptions < numOfSuboptions) {
          maxSuboptions = numOfSuboptions;
        }
      }

    return maxSuboptions;
  }; // end of 'getMaxSuboptions'

  const getElementIndex = (list, element) => {
    let foundIndex = null;

    for (let i = 0; i < list.length; i++) {
      if (list[i] === element) {
        foundIndex = i;
      }
    }

    return foundIndex;
  }; // end of 'getElementIndex'

  const handleChangeCheck = (
    studyAnnotationId,
    optionId,
    suboptionId,
    shouldAdd,
    isOptionPartOfCombination,
    event,
    groupObj
  ) => {
    setEnableReportRegenerate(true);
    let studyAnnotationOptionSelections = null;

    if (annotationState.selections.hasOwnProperty(studyAnnotationId)) {
      studyAnnotationOptionSelections =
        annotationState.selections[studyAnnotationId];
    } else {
      studyAnnotationOptionSelections = {};
      // annotationState.selections[studyAnnotationId] =
      //   studyAnnotationOptionSelections;
      setAnnotationState(() => {
        const newVal = { ...annotationState };
        newVal.selections[studyAnnotationId] = studyAnnotationOptionSelections;
        return newVal;
      });
    }

    if (shouldAdd === 1) {
      let listOfSuboptions = studyAnnotationOptionSelections[optionId];
      if (listOfSuboptions === undefined || listOfSuboptions === null) {
        listOfSuboptions = [];
        studyAnnotationOptionSelections[optionId] = listOfSuboptions;
      }

      let isChecked = event.target.checked;
      if (!isChecked) {
        if (isOptionPartOfCombination) {
          let elementIndex = getElementIndex(listOfSuboptions, suboptionId);
          if (elementIndex != null) {
            listOfSuboptions.splice(elementIndex, 1);
          }

          setAnnotationState(() => {
            const newVal = { ...annotationState };
            newVal.selections[studyAnnotationId][optionId] = listOfSuboptions;
            return newVal;
          });
        }
      } else {
        if (isOptionPartOfCombination) {
          listOfSuboptions.push(suboptionId);
        } else {
          listOfSuboptions.length = 0;
          listOfSuboptions.push(suboptionId);
        }
        setAnnotationState(() => {
          const newVal = { ...annotationState };
          newVal.selections[studyAnnotationId][optionId] = listOfSuboptions;
          return newVal;
        });

        let selectedGroups =
          annotationState.group_selections[studyAnnotationId];

        if (selectedGroups === undefined || selectedGroups === null) {
          selectedGroups = [];
          // annotation_state.group_selections[studyAnnotationId] = selectedGroups;
          setAnnotationState(() => {
            const newVal = { ...annotationState };
            newVal.group_selections[studyAnnotationId] = selectedGroups;
            return newVal;
          });
        }

        if (!containsChecker(selectedGroups, groupObj.groupNumber)) {
          selectedGroups.push(groupObj.groupNumber);
          setAnnotationState(() => {
            const newVal = { ...annotationState };
            newVal.group_selections[studyAnnotationId] = selectedGroups;
            return newVal;
          });
        }
      }
    }
  };

  const handleChangeRadioButton = (
    studyAnnotationId,
    optionId,
    suboptionId,
    shouldAdd,
    isOptionPartOfCombination,
    event,
    groupObj,
    radioData
  ) => {
    setEnableReportRegenerate(true);
    let studyAnnotationOptionSelections = null;

    if (annotationState.selections.hasOwnProperty(studyAnnotationId)) {
      studyAnnotationOptionSelections =
        annotationState.selections[studyAnnotationId];
    } else {
      studyAnnotationOptionSelections = {};
      annotationState.selections[studyAnnotationId] =
        studyAnnotationOptionSelections;
    }

    let listOfSuboptions = studyAnnotationOptionSelections[optionId];
    if (listOfSuboptions === undefined || listOfSuboptions === null) {
      listOfSuboptions = [];
      studyAnnotationOptionSelections[optionId] = listOfSuboptions;
    }
    listOfSuboptions.length = 0;
    listOfSuboptions.push(parseInt(suboptionId));
    setAnnotationState(() => {
      const newVal = { ...annotationState };
      newVal.selections[studyAnnotationId][optionId] = listOfSuboptions;
      return newVal;
    });
    let selectedGroups = annotationState.group_selections[studyAnnotationId];

    if (selectedGroups === undefined || selectedGroups === null) {
      selectedGroups = [];
      // annotation_state.group_selections[studyAnnotationId] = selectedGroups;
      setAnnotationState(() => {
        const newVal = { ...annotationState };
        newVal.group_selections[studyAnnotationId] = selectedGroups;
        return newVal;
      });
    }

    if (!containsChecker(selectedGroups, groupObj.groupNumber)) {
      selectedGroups.push(groupObj.groupNumber);
      setAnnotationState(() => {
        const newVal = { ...annotationState };
        newVal.group_selections[studyAnnotationId] = selectedGroups;
        return newVal;
      });
    }
  };

  const checkForOptionSubOption = (id) => {
    return true;
    if (annotationState.annotations_options_presence_map[id]) {
      return true;
    } else {
      return false;
    }
  };

  const handleAIPathologyEdit = (annotationId) => {

    let updatedAddedAnnotation = addedAnnotation?.map((ele, index) => {
      if (ele.id == annotationId) {
        ele.isAIEdited = true;
      }
      return ele;
    });
    setAddedAnnotation(updatedAddedAnnotation);
  };

  const getUpdateAccToOrder = (opt) => {
    // for (let i = 0; i < opt.length; i++) {
    //   for (let j = 0; j < opt.length - i - 1; j++) {
    //     if (opt[j].name > opt[j + 1].name) {
    //       var temp = opt[j];
    //       opt[j] = opt[j + 1];
    //       opt[j + 1] = temp;
    //     }
    //   }
    // }
    return opt;
  };

  const [submitComplete, setSubmitComplete] = useState(false);
  const [negativeSubmitTriggered, setNegativeSubmitTriggered] = useState(false);

  const handleNegativeSubmitReport = async() =>{
  try {
    const arr = JSON.parse(annotationsJson); // Convert string to array

    // Update annotations
    arr.forEach((value) => {
      addOrRemoveAnnotation(value, 0);
    });

    setNegativeSubmitTriggered(true);
    setSubmitComplete(false);
    submitSelectedOptions();

  } catch (error) {
    console.error("Error in handleNegativeSubmitReport:", error);
  }
};

useEffect(() => {
  if (submitComplete && negativeSubmitTriggered) {
    const chestReport = patientReports.filter(
  item => item.reportDetails?.reportTemplateTitle === "Auto Chest Report"
);
    handleSubmitReport(
      true, keyImages, annotationData, annotationDataAI, allTextToolAnnotation,
      activeViewportIndex, false, false, undefined, undefined, chestReport, false
    );
     setNegativeSubmitTriggered(false);
  }
}, [submitComplete,negativeSubmitTriggered]);

  const handleMovePathologyArchived = (annotationObj, reverse, autoLock) => {
    
    if (autoLock != null && autoLock != undefined) {
      autoLock = true;
    } else {
      autoLock = false;
    }

    if (!reverse) {
      const objectToMove = archivedPathology.find(
        (item) => item.id === annotationObj.id
      );

      if (objectToMove) {
        const updatedAnnotations = allAnnotations.filter(
          (item) => item.id !== objectToMove.id
        );
        setAllAnnotation(updatedAnnotations);

        // Remove the object from setState1
        const updatedState1 = archivedPathology.filter(
          (item) => item.id !== annotationObj.id
        );
        if (
          objectToMove.is_present == null ||
          objectToMove.is_present == undefined
        ) {
          objectToMove["is_present"] = 1;
        }

        if (autoLock) {
          objectToMove.is_locked = true;
          objectToMove.is_annotated = true;
        }
        // Add the object to setState2

        const updatedState2 = [...addedAnnotation, objectToMove];
        let tempAnnotationState = annotationState.annotations_stuff;
        for (let i = 0; i < tempAnnotationState.length; i++) {
          let annotationObj = tempAnnotationState[i];
          let id = annotationObj.id;

          if (id === objectToMove.id) {
            annotationObj.is_present = 1;
            if (
              annotationObj.is_annotation_check == undefined ||
              annotationObj.is_annotation_check == null
            ) {
              annotationObj["is_annotation_check"] = autoLock ? true : false;
            } else {
              annotationObj.is_annotation_check = autoLock ? true : false;
            }
            if (
              annotationObj.is_locked_check == undefined ||
              annotationObj.is_locked_check == null
            ) {
              annotationObj["is_locked_check"] = autoLock ? true : false;
            } else {
              annotationObj.is_locked_check = autoLock ? true : false;
            }
            if (
              annotationObj.is_locked == undefined ||
              annotationObj.is_locked == null
            ) {
              annotationObj["is_locked"] = autoLock ? true : false;
            } else {
              annotationObj.is_locked = autoLock ? true : false;
            }
            if (
              annotationObj.is_annotated == undefined ||
              annotationObj.is_annotated == null
            ) {
              annotationObj["is_annotated"] = autoLock ? true : false;
            } else {
              annotationObj.is_annotated = autoLock ? true : false;
            }
            if (annotationObj.isAI == undefined || annotationObj.isAI == null) {
              annotationObj["isAI"] = autoLock ? true : false;
            } else {
              annotationObj.isAI = true;
            }
            annotationObj.sequence_num = ++annotationState.sequence_num;
          }
          tempAnnotationState[i] = annotationObj;
        }

        // Update both state variables
        setAnnotationState(() => {
          const newVal = { ...annotationState };
          newVal.annotations_stuff = tempAnnotationState;
          return newVal;
        });
        setArchivedPathology(updatedState1);
        setAddedAnnotation(updatedState2);
      }
    } else {
      if (annotationObj && annotationObj.ai_predicted == 1) {
        const objectToMove = addedAnnotation.find(
          (item) => item.id === annotationObj.id
        );

        let tempAllAnnotations = allAnnotations;
        if (!tempAllAnnotations.some((item2) => objectToMove.id === item2.id)) {
          tempAllAnnotations.push({
            id: objectToMove.id,
            name: objectToMove.name,
          });
        }
        tempAllAnnotations = getUpdateAccToOrder(allAnnotations);
        setAllAnnotation(tempAllAnnotations);

        if (objectToMove) {
          if (
            objectToMove.is_annotation_check != undefined ||
            objectToMove.is_annotation_check != null
          ) {
            objectToMove.is_annotation_check = false;
          }
          if (
            objectToMove.is_locked_check != undefined ||
            objectToMove.is_locked_check != null
          ) {
            objectToMove.is_locked_check = false;
          }
          if (
            objectToMove.is_locked != undefined ||
            objectToMove.is_locked != null
          ) {
            objectToMove.is_locked = false;
          }
          if (
            objectToMove.is_annotated != undefined ||
            objectToMove.is_annotated != null
          ) {
            objectToMove.is_annotated = false;
          }

          objectToMove.is_present = 1;
          const updatedState2 = [...archivedPathology, objectToMove];

          let tempAnnotationState = annotationState.annotations_stuff;
          for (let i = 0; i < tempAnnotationState.length; i++) {
            let annotationObj = tempAnnotationState[i];
            let id = annotationObj.id;

            if (id === objectToMove.id) {
              annotationObj.is_present = 1;
              if (
                annotationObj.is_annotation_check == undefined ||
                annotationObj.is_annotation_check == null
              ) {
                annotationObj["is_annotation_check"] = false;
              } else {
                annotationObj.is_annotation_check = false;
              }
              if (
                annotationObj.is_locked_check == undefined ||
                annotationObj.is_locked_check == null
              ) {
                annotationObj["is_locked_check"] = false;
              } else {
                annotationObj.is_locked_check = false;
              }
              if (
                annotationObj.is_locked == undefined ||
                annotationObj.is_locked == null
              ) {
                annotationObj["is_locked"] = false;
              } else {
                annotationObj.is_locked = false;
              }
              if (
                annotationObj.is_annotated == undefined ||
                annotationObj.is_annotated == null
              ) {
                annotationObj["is_annotated"] = false;
              } else {
                annotationObj.is_annotated = false;
              }
              if (
                annotationObj.isAI == undefined ||
                annotationObj.isAI == null
              ) {
                annotationObj["isAI"] = true;
              } else {
                annotationObj.isAI = true;
              }
              annotationObj.sequence_num = ++annotationState.sequence_num;
            }
            tempAnnotationState[i] = annotationObj;
          }

          setAnnotationState(() => {
            const newVal = { ...annotationState };
            newVal.annotations_stuff = tempAnnotationState;
            return newVal;
          });

          if (
            !archivedPathology.some((item2) => objectToMove.id === item2.id)
          ) {
              setArchivedPathology(updatedState2);
          }
        }
      }
    }
  };

  return (
    <AnnotationContext.Provider
      value={{
        allAnnotations,
        setAllAnnotation,
        annotationState,
        addedAnnotation,
        containsChecker,
        addOrRemoveAnnotation,
        getAnnotationData,
        getListOfGroups,
        searchInputValue,
        setSearchInputValue,
        dimension,
        paginatedAnnotation,
        setAddedAnnotation,
        tempAnnotation,
        createAnnotationJson,
        handleUpdateAnnotationState,
        handleCheckTab,
        getMaxSuboptions,
        handleChangeCheck,
        handleChangeRadioButton,
        handleNegativeSubmitReport,

        tabs,
        setTabs,
        checkTab,
        setCheckedTab,
        tabContent,
        setTabContent,
        submitSelectedOptions,
        addStudyAnnotation,
        setAnnotationState,
        checkForOptionSubOption,
        handleAIPathologyEdit,
        handleDefaultGroupAndOptionsSelectionsBeforeSubmit,
        handleAddingAnnotations,
        annotationStateStore,
        setAnnotationStateStore,
        handleMovePathologyArchived,
        selectAIPathology,
        allStoreAnnotations,
        setAllStoreAnnotations,
        addedChildAnnotation,
        pathologiesLoading,
        childPathologyPresentObj,
        classificationStateStore, 
        setClassificationStateStore,
        childClassificationState,
        checkIfAITagLocked
      }}
    >
      {props.children}
    </AnnotationContext.Provider>
  );
};

export default AnnotationState;
